import { render, staticRenderFns } from "./IconSingleArrowLeft.vue?vue&type=template&id=70c9c9da&scoped=true&"
import script from "./IconSingleArrowLeft.vue?vue&type=script&lang=ts&"
export * from "./IconSingleArrowLeft.vue?vue&type=script&lang=ts&"
import style0 from "./IconSingleArrowLeft.vue?vue&type=style&index=0&id=70c9c9da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9c9da",
  null
  
)

export default component.exports